module.exports = __webpack_public_path__ + "static/media/worksheet-61925.a7bc8e05.jpeg";